const {__, _x, _n, _nx} = wp.i18n;

// Bootstrap Offcanvas/Collapse (data-API) + utilities du menu mobile → déplacés
// dans menu.js (entry EAGER, exclu du Delay JS) pour que le burger réponde
// immédiatement, sans attendre ce bundle qui reste délayé pour le score CWV.
// Ne PAS réimporter Bootstrap ici.

require('./utilities/class_enlarge.js');
//require('./utilities/class_count.js');
require('./utilities/pdw_modal_search.js');
require('./utilities/pdw_carousel.js');
require('./utilities/pdw_hide_link.js');
require('./utilities/pdw_scrolled.js');
require('./utilities/pdw_lightbox.js');
require('./utilities/km_promos.js');
require('./utilities/km_services.js');
require('./utilities/km_univers.js');
require('./utilities/km_apropos.js');
require('./utilities/km_news.js');
require('./utilities/km_zigzag_build.js');
require('./utilities/km_signature.js');
require('./utilities/km_prefooter.js');
require('./utilities/km_avis.js');
require('./utilities/km_marques.js');
require('./utilities/km_produit.js');
require('./utilities/km_hero_parallax.js');
require('./utilities/km_smooth.js');
require('./utilities/anim_init.js');
//require('./utilities/pdw_woocommerce.js');
